import { defaultScheduler } from "@studiometa/js-toolkit";
import { fallbackStore as store } from "../utils/storage/index.js";
const key = "layout";
const layouts = /* @__PURE__ */ new Set(["top", "right", "bottom", "left"]);
const defaultLayout = "top";
async function getLayout() {
  return await store.get(key) || defaultLayout;
}
async function layoutIs(position) {
  return await getLayout() === position;
}
async function layoutIsVertical() {
  const layout = await getLayout();
  return layout === "left" || layout === "right";
}
async function layoutIsHoritontal() {
  const layout = await getLayout();
  return layout === "top" || layout === "bottom";
}
async function layoutUpdateDOM(value) {
  const layout = value ?? await getLayout();
  defaultScheduler.write(() => {
    document.documentElement.classList.toggle("is-top", layout === "top");
    document.documentElement.classList.toggle("is-right", layout === "right");
    document.documentElement.classList.toggle("is-bottom", layout === "bottom");
    document.documentElement.classList.toggle("is-left", layout === "left");
  });
}
async function setLayout(value) {
  let layout = value ?? await getLayout();
  if (!layouts.has(layout)) {
    console.log(`The "${layout}" layout is not valid.`);
    layout = defaultLayout;
  }
  await Promise.all([store.set(key, layout), layoutUpdateDOM(layout)]);
}
function watchLayout(callback) {
  return store.watch((k, newValue) => k === key && callback(newValue));
}
export {
  getLayout,
  layoutIs,
  layoutIsHoritontal,
  layoutIsVertical,
  layoutUpdateDOM,
  setLayout,
  watchLayout
};
//# sourceMappingURL=layout.js.map
